import React from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Switch } from './ui/switch';
import { Plus, Trash } from '@phosphor-icons/react';
import { eur } from './QuoteDetails';

export const emptyItem = () => ({ description: '', quantity: 1, unit_price: '' });
export const itemsInvalid = (items) => items.some((i) => !i.description.trim() || !(Number(i.quantity) > 0) || i.unit_price === '');
export const cleanItems = (items) => items.map((i) => ({ description: i.description.trim(), quantity: Number(i.quantity), unit_price: Number(i.unit_price) }));
export const subtotalOf = (items) => items.reduce((s, i) => s + Number(i.quantity || 0) * Number(i.unit_price || 0), 0);

const ItemRow = ({ item, idx, onChange, onRemove, canRemove, prefix }) => (
  <div className="grid grid-cols-12 gap-2 items-center" data-testid={`${prefix}-item-row-${idx}`}>
    <Input className="col-span-6" placeholder="Prestazione / voce" value={item.description}
      onChange={(e) => onChange(idx, 'description', e.target.value)} data-testid={`${prefix}-item-desc-${idx}`} />
    <Input className="col-span-2" type="number" min="0" step="0.5" value={item.quantity}
      onChange={(e) => onChange(idx, 'quantity', e.target.value)} data-testid={`${prefix}-item-qty-${idx}`} />
    <Input className="col-span-3" type="number" min="0" step="0.01" placeholder="€" value={item.unit_price}
      onChange={(e) => onChange(idx, 'unit_price', e.target.value)} data-testid={`${prefix}-item-price-${idx}`} />
    <button type="button" className="col-span-1 text-slate-400 hover:text-red-600 disabled:opacity-30" disabled={!canRemove}
      onClick={() => onRemove(idx)} data-testid={`${prefix}-item-remove-${idx}`} aria-label="Rimuovi voce"><Trash size={18} /></button>
  </div>
);

export const ItemsEditor = ({ items, setItems, prefix = 'quote' }) => {
  const change = (idx, k, v) => setItems(items.map((it, i) => (i === idx ? { ...it, [k]: v } : it)));
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-12 gap-2 text-xs text-slate-500"><span className="col-span-6">Voce</span><span className="col-span-2">Quantità</span><span className="col-span-3">Prezzo unitario</span></div>
      {items.map((it, idx) => (
        <ItemRow key={idx} item={it} idx={idx} onChange={change} canRemove={items.length > 1} prefix={prefix}
          onRemove={(i) => setItems(items.filter((_, j) => j !== i))} />
      ))}
      <Button type="button" variant="ghost" size="sm" onClick={() => setItems([...items, emptyItem()])} data-testid={`${prefix}-add-item-btn`}>
        <Plus size={16} className="mr-1" /> Aggiungi voce
      </Button>
    </div>
  );
};

export const VatTotals = ({ items, vatEnabled, setVatEnabled, vatRate, setVatRate, prefix = 'quote' }) => {
  const subtotal = subtotalOf(items);
  const vat = vatEnabled ? subtotal * Number(vatRate || 0) / 100 : 0;
  return (
    <div className="flex flex-wrap items-center gap-4">
      <label className="flex items-center gap-2 text-sm"><Switch checked={vatEnabled} onCheckedChange={setVatEnabled} data-testid={`${prefix}-vat-switch`} /> Applica IVA</label>
      {vatEnabled && <Input className="w-24" type="number" min="0" max="100" value={vatRate} onChange={(e) => setVatRate(e.target.value)} data-testid={`${prefix}-vat-rate-input`} />}
      <div className="ml-auto text-right text-sm">
        <div>Imponibile {eur(subtotal)}{vatEnabled && ` · IVA ${eur(vat)}`}</div>
        <div className="font-heading font-semibold text-primary text-lg" data-testid={`${prefix}-form-total`}>Totale {eur(subtotal + vat)}</div>
      </div>
    </div>
  );
};
